import React, { useEffect } from 'react';
import moment from 'moment';

import useGlobal from '../../../store';
import Table from '../../../facturotopia/table/Table';
import RenderItemStatus from '../../../modulos/autofacturacion/tickets/components/RenderItemStatus';

const mapState = (store) => {
  return store.external.receptores.autofacturacion.list;
};

const mapActions = (actions) => {
  return { ...actions.external.receptores.autofacturacion.list };
};

const AutofacturacionTicketList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      actions.paginate({
        page: 1,
        from,
        to,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { from = '', to = '' } = state.filters;

    const newMeta = {
      ...meta,
      from,
      to,
    };

    actions.paginate(newMeta);
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  // const setSelectedRows = (event) => {
  //   actions.setSelectedRows(event);

  //   !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  // }

  // const getRowSelectionConfig = () => {
  //   const { selectedRowKeys = [] } = props;

  //   return {
  //     type: 'checkbox',
  //     selectedRowKeys,
  //     onChange: setSelectedRows,
  //     getCheckboxProps: record => ({
  //       name: record.name,
  //     }),
  //   }
  // }

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      onRowClick={onRowClick}
      // rowSelection={ getRowSelectionConfig() }
    ></Table>
  );
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
    className: 'cell-medium',
  },
  {
    key: 'codigo',
    title: 'Código',
    dataIndex: 'codigo',
    className: 'cell-small',
  },
  {
    key: 'emisor_rfc',
    title: 'Emisor',
    dataIndex: 'emisor_rfc',
  },
  {
    key: 'fecha_servicio',
    title: 'Fecha servicio',
    dataIndex: 'fecha_servicio',
    className: 'cell-medium',
  },
  {
    key: 'forma_de_pago',
    title: 'Forma Pago',
    dataIndex: 'forma_de_pago',
    align: 'center',
  },
  {
    key: 'metodo_de_pago',
    title: 'Método Pago',
    dataIndex: 'metodo_de_pago',
    align: 'center',
  },
  {
    key: 'subtotal',
    title: 'Subtotal',
    dataIndex: 'subtotal',
    align: 'right',
  },
  {
    key: 'descuento',
    title: 'Descuento',
    dataIndex: 'descuento',
    align: 'right',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'right',
  },
  {
    key: 'cfdi_uuid',
    title: 'Cfdi Uuid',
    dataIndex: 'cfdi_uuid',
    align: 'center',
    className: 'cell-xxlarge',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <RenderItemStatus item={item} />,
  },
];

export default AutofacturacionTicketList;
